<template>
  <NextButton
    v-bind="$attrs"
    v-on="$listeners"
    :class="$style.root"
  />
</template>

<script>
import NextButton from './NextButton'
import Anicss from '@/components/Anicss'

export default {
  components: {
    NextButton,
    Anicss,
  },
}
</script>

<style lang="scss" module>
.root {
  @apply left-0;
  @apply ml-8;
  @apply mr-auto;
  @apply right-auto;
  transform: scale(-1, 1);
}
</style>
